import { NgModule } from '@angular/core';

import { DeclineOrderDialogComponent } from './decline-order-dialog.component';

import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';
import { MaterialModule } from 'app/main/material.module';
import { DialogHeaderModule } from 'app/components/dialogs/dialog-header/dialog-header.module';

@NgModule({
    declarations: [
        DeclineOrderDialogComponent,
    ],
    imports: [
        TranslateModule,
        FuseSharedModule,
        MaterialModule,
        DialogHeaderModule,
    ],
    exports: [
        DeclineOrderDialogComponent,
    ]
})

export class DeclineOrderDialogModule
{
}
